var BASWebServices;
(function (BASWebServices) {
    var QuestionAnswerPair = (function () {
        function QuestionAnswerPair(categoryT, questionT, answerT) {
            this.category = categoryT;
            this.question = questionT;
            this.answer = answerT;
        }
        QuestionAnswerPair.prototype.getQuestion = function () {
            return this.question;
        };
        QuestionAnswerPair.prototype.getAnswert = function () {
            return this.answer;
        };
        return QuestionAnswerPair;
    }());
    var FAQController = (function () {
        function FAQController($scope, $timeout, faqs) {
            this.$scope = $scope;
            this.$timeout = $timeout;
            this.faqs = faqs;
            $scope.faqc = this;
            var _scope = this.$scope;
            this.faqs.getFAQContent().then(function (response) {
                var contentSplit = response.data.split("\n");
                var content = "";
                for (var i = 0; i < contentSplit.length; i++) {
                    if (contentSplit[i].indexOf("#") == 0)
                        continue;
                    else
                        content += contentSplit[i] + "\n";
                }
                var dataSplit = content.split("----------\n");
                var categoryQuestionAnswerStructure = {};
                for (var i = 1; i < dataSplit.length; i++) {
                    var currBlock = dataSplit[i];
                    currBlock = currBlock.replace(/\n/g, '');
                    var categorySplit = currBlock.split("Q: ");
                    var category = "Else";
                    if (categorySplit[0] !== "") {
                        category = categorySplit[0].substring(3);
                    }
                    var questionAnswerSplit = categorySplit[1].split("A: ");
                    var question = questionAnswerSplit[0];
                    var answer = questionAnswerSplit[1];
                    var qap = new QuestionAnswerPair(category, question, answer);
                    if (categoryQuestionAnswerStructure[category] === undefined || categoryQuestionAnswerStructure[category] === null) {
                        categoryQuestionAnswerStructure[category] = new Array();
                    }
                    categoryQuestionAnswerStructure[category].push(qap);
                }
                _scope.FAQ_CONTENT = categoryQuestionAnswerStructure;
            }, function (reason) {
                _scope.FAQ_CONTENT["Else"].push(new QuestionAnswerPair("N/A", "N/A", "N/A"));
                console.error("Could not retrieve WebMAUS version from url " + BASWebServices.ConfigService.GET_FAQ_URL());
                console.error("Failing with error: " + reason);
            });
        }
        FAQController.prototype.filterClear = function () {
            this.$scope.searchText = '';
        };
        return FAQController;
    }());
    BASWebServices.FAQController = FAQController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=FAQController.js.map